/* ZipRoar theme behaviour: product buy box, gallery, announcement bar,
   email pop-up, animal gallery and cart add-on clean-up. No dependencies. */
(function () {
  'use strict';

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function storage(key, val) {
    try {
      if (val === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, val);
    } catch (e) { return null; }
  }

  function formatMoney(cents, format) {
    var fmt = format || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, kind) {
      switch (kind) {
        case 'amount_no_decimals': return withCommas;
        case 'amount_with_comma_separator': return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
        case 'amount_no_decimals_with_comma_separator': return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        default: return withCommas + '.' + parts[1];
      }
    });
  }

  var REDUCED = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var TOUCH = !!(window.matchMedia && window.matchMedia('(pointer: coarse)').matches);

  // small "press" bounce for a tapped control
  function pop(el, from) {
    if (REDUCED || !el || !el.animate) return;
    el.animate([{ transform: 'scale(' + (from || 0.92) + ')' }, { transform: 'scale(1.04)' }, { transform: 'none' }], { duration: 300, easing: 'cubic-bezier(.2,.8,.2,1)' });
  }
  function buzz(ms) {
    if (!TOUCH || !navigator.vibrate) return;
    try { navigator.vibrate(ms || 10); } catch (e) {}
  }

  /* ------------------------------------------------------------------
     Gallery
     ------------------------------------------------------------------ */
  function Gallery(root) {
    this.root = root;
    this.track = $('[data-zr-track]', root);
    this.slides = $$('.zr-gal__slide', root);
    this.thumbs = $$('[data-zr-thumb]', root);
    this.count = $('[data-zr-count]', root);
    this.index = 0;
    if (!this.track || !this.slides.length) return;
    var self = this;
    var prev = $('[data-zr-prev]', root);
    var next = $('[data-zr-next]', root);
    if (prev) prev.addEventListener('click', function () { self.go(self.index - 1); });
    if (next) next.addEventListener('click', function () { self.go(self.index + 1); });
    this.thumbs.forEach(function (t) {
      t.addEventListener('click', function () { self.go(parseInt(t.getAttribute('data-zr-thumb'), 10)); });
    });
    var ticking = false;
    this.track.addEventListener('scroll', function () {
      if (ticking || self.jumping) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var i = Math.round(self.track.scrollLeft / self.track.clientWidth);
        if (i !== self.index) self.mark(i);
      });
    }, { passive: true });
    this.track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self.index + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self.index - 1); }
    });
    this.hint();
  }
  // On phones, nudge the photos once so people see they can swipe.
  Gallery.prototype.hint = function () {
    var self = this, track = this.track;
    if (!TOUCH || REDUCED || this.slides.length < 2 || !('IntersectionObserver' in window) || storage('zr_swipe_hint')) return;
    var io = new IntersectionObserver(function (entries) {
      if (!entries[0].isIntersecting || self.index !== 0) return;
      io.disconnect();
      storage('zr_swipe_hint', '1');
      setTimeout(function () {
        self.jumping = true;
        track.style.scrollSnapType = 'none';
        track.scrollTo({ left: 56, behavior: 'smooth' });
        setTimeout(function () {
          track.scrollTo({ left: 0, behavior: 'smooth' });
          setTimeout(function () { track.style.scrollSnapType = ''; self.jumping = false; }, 450);
        }, 420);
      }, 500);
    }, { threshold: 0.6 });
    io.observe(track);
  };
  Gallery.prototype.mark = function (i) {
    this.index = i;
    if (this.count) this.count.textContent = (i + 1) + ' / ' + this.slides.length;
    this.thumbs.forEach(function (t, k) {
      if (k === i) {
        t.setAttribute('aria-current', 'true');
        // keep the active thumbnail in the middle of the strip
        var box = t.parentElement;
        if (box) box.scrollTo({ left: t.offsetLeft - (box.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
      } else {
        t.removeAttribute('aria-current');
      }
    });
  };
  Gallery.prototype.go = function (i, instant) {
    if (!this.track) return;
    var self = this, n = this.slides.length;
    i = ((i % n) + n) % n;
    // Neighbouring slides glide; far jumps (picking another animal) cut straight there.
    var far = Math.abs(i - this.index) > 1;
    this.jumping = true;
    clearTimeout(this.jumpTimer);
    this.jumpTimer = setTimeout(function () { self.jumping = false; }, far || instant ? 80 : 600);
    this.track.scrollTo({ left: i * this.track.clientWidth, behavior: instant || far ? 'instant' : 'smooth' });
    if (far && !instant && this.track.animate) this.track.animate([{ opacity: 0.35, transform: 'scale(.985)' }, { opacity: 1, transform: 'none' }], { duration: 260, easing: 'ease-out' });
    this.mark(i);
  };
  Gallery.prototype.goToMedia = function (mediaId, instant) {
    if (!mediaId || !this.slides) return;
    for (var i = 0; i < this.slides.length; i++) {
      if (this.slides[i].getAttribute('data-media-id') === String(mediaId)) { this.go(i, instant); return; }
    }
  };

  /* ------------------------------------------------------------------
     Product buy box
     ------------------------------------------------------------------ */
  function Product(root) {
    var raw = $('[data-zr-data]', root);
    if (!raw) return;
    this.root = root;
    this.data = JSON.parse(raw.textContent);
    this.variants = this.data.variants;
    this.gallery = new Gallery($('[data-zr-gallery]', root));
    this.isMain = !!$('h1.zr-info__title', root);

    var start = this.byId(this.data.current) || this.variants[0];
    this.units = [start.o.slice()];
    this.active = 0;
    this.qty = 1;

    this.atc = $('[data-zr-atc]', root);
    this.atcText = $('[data-zr-atc-text]', root);
    this.err = $('[data-zr-err]', root);
    this.unitsBox = $('[data-zr-units]', root);
    this.protect = $('[data-zr-protect]', root);
    this.sticky = $('[data-zr-sticky]', root);

    this.bind();
    this.render();
    this.eta();
    if (start.m) this.gallery.goToMedia(start.m, true);
  }

  Product.prototype.byId = function (id) {
    for (var i = 0; i < this.variants.length; i++) if (this.variants[i].id === id) return this.variants[i];
    return null;
  };
  Product.prototype.find = function (opts) {
    for (var i = 0; i < this.variants.length; i++) {
      var v = this.variants[i], ok = true;
      for (var k = 0; k < opts.length; k++) if (v.o[k] !== opts[k]) { ok = false; break; }
      if (ok) return v;
    }
    return null;
  };
  Product.prototype.money = function (c) { return formatMoney(c, this.data.money); };

  Product.prototype.bind = function () {
    var self = this, root = this.root;

    $$('[data-zr-opt]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.getAttribute('data-zr-opt'), 10);
        var val = btn.getAttribute('data-value');
        var sel = self.units[self.active].slice();
        sel[idx] = val;
        // If that exact combination is sold out, keep the clicked value and
        // move the other options to the first available match.
        var v = self.find(sel);
        if (!v || !v.a) {
          for (var i = 0; i < self.variants.length; i++) {
            if (self.variants[i].a && self.variants[i].o[idx] === val) { sel = self.variants[i].o.slice(); break; }
          }
        }
        self.units[self.active] = sel;
        self.hideError();
        self.render();
        pop(btn);
        buzz(8);
        var nv = self.find(sel);
        if (nv && nv.m) self.gallery.goToMedia(nv.m);
      });
      btn.addEventListener('keydown', function (e) {
        if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(e.key) === -1) return;
        e.preventDefault();
        var group = $$('[data-zr-opt="' + btn.getAttribute('data-zr-opt') + '"]', root);
        var i = group.indexOf(btn) + (e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1 : -1);
        var target = group[(i + group.length) % group.length];
        target.focus();
        target.click();
      });
    });

    $$('[data-zr-tier]', root).forEach(function (r) {
      r.addEventListener('change', function () {
        var n = parseInt(r.value, 10);
        var prev = self.qty;
        self.qty = n;
        while (self.units.length < n) self.units.push(self.units[self.units.length - 1].slice());
        self.units.length = n;
        self.active = n > prev ? prev : Math.min(self.active, n - 1);
        self.hideError();
        self.render();
        pop(r.closest('.zr-tier'), 0.96);
        pop(self.atc, 0.97);
        buzz(8);
      });
    });

    if (this.protect) this.protect.addEventListener('change', function () { self.render(); });
    if (this.atc) this.atc.addEventListener('click', function () { self.add(); });

    if (this.sticky && this.atc && 'IntersectionObserver' in window) {
      var btn = $('[data-zr-sticky-btn]', this.sticky);
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var on = !e.isIntersecting && e.boundingClientRect.top < 0;
        self.sticky.classList.toggle('is-on', on);
        self.sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
        btn.tabIndex = on ? 0 : -1;
      }).observe(this.atc);
      btn.addEventListener('click', function () {
        self.atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    }
  };

  Product.prototype.render = function () {
    var self = this, root = this.root;
    var sel = this.units[this.active];

    // option buttons: selected + availability given the other selections
    $$('[data-zr-opt]', root).forEach(function (btn) {
      var idx = parseInt(btn.getAttribute('data-zr-opt'), 10);
      var val = btn.getAttribute('data-value');
      btn.setAttribute('aria-checked', sel[idx] === val ? 'true' : 'false');
      btn.tabIndex = sel[idx] === val ? 0 : -1;
      var test = sel.slice(); test[idx] = val;
      var v = self.find(test);
      if (v && v.a) btn.removeAttribute('data-unavailable'); else btn.setAttribute('data-unavailable', '');
    });
    $$('[data-zr-optlabel]', root).forEach(function (el) {
      el.textContent = sel[parseInt(el.getAttribute('data-zr-optlabel'), 10)] || '';
    });

    // which-suit chips
    if (this.unitsBox) {
      this.unitsBox.hidden = this.qty < 2;
      this.unitsBox.innerHTML = '';
      if (this.qty > 1) {
        this.units.forEach(function (u, i) {
          var v = self.find(u);
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'zr-unit';
          b.setAttribute('aria-pressed', i === self.active ? 'true' : 'false');
          var img = document.createElement('img');
          img.alt = '';
          img.src = v && v.img ? v.img : '';
          var t = document.createElement('span');
          var size = (u[1] || '').split('(')[0].replace(' Months', ' mo');
          t.innerHTML = 'Suit ' + (i + 1) + '<small></small>';
          t.querySelector('small').textContent = u[0] + (size ? ' · ' + size : '');
          b.appendChild(img);
          b.appendChild(t);
          b.addEventListener('click', function () {
            self.active = i;
            self.render();
            var vv = self.find(self.units[i]);
            if (vv && vv.m) self.gallery.goToMedia(vv.m);
          });
          self.unitsBox.appendChild(b);
        });
      }
    }

    // total
    var pct = (this.data.bundle && this.data.bundle[this.qty - 1]) || 0;
    var total = 0, allOk = true;
    this.units.forEach(function (u) {
      var v = self.find(u);
      if (!v || !v.a) { allOk = false; return; }
      var off = Math.ceil(v.p * pct / 100);
      total += v.p - off;
    });
    if (this.protect && this.protect.checked) {
      var addon = this.protect.closest('.zr-addon');
      var pTxt = addon ? addon.querySelector('b') : null;
      var cents = pTxt ? Math.round(parseFloat(pTxt.textContent.replace(/[^0-9.,]/g, '').replace(',', '.')) * 100) : 0;
      total += cents || 0;
    }
    if (this.atc) {
      var label = this.atc.getAttribute('data-label') || 'Add to cart';
      // Name what they're buying: "Add Panda to cart", "Add 2 suits to cart" (falls back if too long for a phone)
      if (/^add to cart$/i.test(label)) {
        var what = this.qty > 1 ? this.qty + ' suits' : (sel[0] || '');
        var named = 'Add ' + what + ' to cart';
        if (what && named.length <= 24) label = named;
      }
      this.atc.disabled = !allOk;
      this.atcText.textContent = allOk ? label + ' · ' + this.money(total) : 'Sold out – pick another size';
    }

    // sticky + url
    var first = this.find(this.units[0]);
    if (this.sticky && first) {
      var st = $('[data-zr-sticky-title]', this.sticky), sp = $('[data-zr-sticky-price]', this.sticky);
      var si = $('[data-zr-sticky-img]', this.sticky);
      if (si && first.img) si.src = first.img;
      if (st) st.textContent = this.qty > 1 ? this.qty + ' suits' : first.o.join(' / ');
      if (sp) sp.textContent = this.money(total);
    }
    if (this.isMain && first && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', first.id);
      window.history.replaceState({}, '', url.toString());
    }
  };

  Product.prototype.hideError = function () { if (this.err) this.err.hidden = true; };
  Product.prototype.showError = function (msg) {
    if (!this.err) return;
    this.err.textContent = msg;
    this.err.hidden = false;
  };

  Product.prototype.add = function () {
    var self = this, items = [], map = {};
    for (var i = 0; i < this.units.length; i++) {
      var v = this.find(this.units[i]);
      if (!v || !v.a) {
        this.active = i;
        this.render();
        this.showError('Suit ' + (i + 1) + ' is sold out in that size. Please pick another one.');
        return;
      }
      map[v.id] = (map[v.id] || 0) + 1;
    }
    Object.keys(map).forEach(function (id) { items.push({ id: parseInt(id, 10), quantity: map[id] }); });
    var protectId = this.protect && this.protect.checked ? parseInt(this.protect.value, 10) : 0;

    this.hideError();
    this.atc.disabled = true;
    this.atc.classList.add('is-busy');
    var ok = false;

    function post(list) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: list })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'error'); return j; }); });
    }

    // Protection is added first (once per cart) so the cart lists the suits above it.
    fetch('/cart.js').then(function (r) { return r.json(); })
      .then(function (cart) {
        var has = cart.items.some(function (i) { return i.variant_id === protectId; });
        return protectId && !has ? post([{ id: protectId, quantity: 1 }]) : null;
      })
      .then(function () { return post(items); })
      .then(function () { ok = true; return refreshCart(true); })
      .catch(function (e) {
        self.showError(e && e.message && e.message !== 'error' ? e.message : 'Something went wrong. Please try again.');
        if (self.atc.animate && !REDUCED) self.atc.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(-3px)' }, { transform: 'none' }], { duration: 320 });
      })
      .then(function () {
        self.atc.classList.remove('is-busy');
        self.render();
        if (ok) self.added();
      });
  };

  // Brief "Added" state on the button, a bounce on the cart icon and a tap of vibration.
  Product.prototype.added = function () {
    var self = this;
    buzz([12, 40, 12]);
    this.atc.classList.add('is-added');
    this.atcText.textContent = 'Added to cart ✓';
    pop(this.atc, 0.95);
    pop(document.getElementById('cart-icon-bubble'), 0.7);
    clearTimeout(this.addedTimer);
    this.addedTimer = setTimeout(function () { self.atc.classList.remove('is-added'); self.render(); }, 1600);
  };

  Product.prototype.eta = function () {
    var box = $('[data-zr-eta]', this.root);
    if (!box) return;
    var proc = parseInt(box.getAttribute('data-proc'), 10) || 0;
    var min = parseInt(box.getAttribute('data-min'), 10) || 0;
    var max = parseInt(box.getAttribute('data-max'), 10) || 0;
    function addBiz(date, n) {
      var d = new Date(date.getTime());
      while (n > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) n--;
      }
      return d;
    }
    function fmt(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
    var now = new Date();
    var ship = addBiz(now, proc);
    $('[data-zr-eta-arrive]', box).textContent = 'Free delivery ' + fmt(addBiz(ship, min)) + ' – ' + fmt(addBiz(ship, max));
    $('[data-zr-eta-ship]', box).textContent = 'Order today, ships by ' + fmt(ship);
  };

  /* ------------------------------------------------------------------
     Cart drawer refresh + add-on clean-up
     ------------------------------------------------------------------ */
  var ADDON_HANDLES = ['shipping-protection'];

  function refreshCart(open) {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.renderContents !== 'function') {
      if (open) window.location.href = '/cart';
      return Promise.resolve();
    }
    return fetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents({ id: null, sections: sections });
        if (!open) setTimeout(function () { if (drawer.close) drawer.close(); }, 0);
      });
  }

  var cleaning = false;
  function cleanAddons(cart) {
    if (cleaning || !cart || !cart.items || !cart.items.length) return;
    var onlyAddons = cart.items.every(function (i) { return ADDON_HANDLES.indexOf(i.handle) > -1; });
    if (!onlyAddons) return;
    cleaning = true;
    var updates = {};
    cart.items.forEach(function (i) { updates[i.key] = 0; });
    fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: updates }) })
      .then(function () {
        var drawer = document.querySelector('cart-drawer');
        var wasOpen = drawer && drawer.classList.contains('active');
        if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
        return refreshCart(wasOpen);
      })
      .catch(function () {})
      .then(function () { cleaning = false; });
  }

  function watchCart() {
    // Dawn declares these with const/function in constants.js and pubsub.js,
    // so they live in the shared global scope but not on window.
    /* global subscribe, PUB_SUB_EVENTS */
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event && event.cartData && event.cartData.items) cleanAddons(event.cartData);
        else fetch('/cart.js').then(function (r) { return r.json(); }).then(cleanAddons).catch(function () {});
      });
    }
    if (document.querySelector('.cart-count-bubble')) {
      fetch('/cart.js').then(function (r) { return r.json(); }).then(cleanAddons).catch(function () {});
    }
  }

  /* ------------------------------------------------------------------
     Announcement bar
     ------------------------------------------------------------------ */
  function announcement(root) {
    var msgs = $$('.zr-ann__msg', root);
    if (msgs.length < 2) return;
    var i = 0, speed = parseInt(root.getAttribute('data-speed'), 10) || 4000, timer;
    function step() {
      msgs[i].classList.remove('is-on'); msgs[i].setAttribute('aria-hidden', 'true');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-on'); msgs[i].removeAttribute('aria-hidden');
    }
    function start() { stop(); timer = setInterval(step, speed); }
    function stop() { if (timer) clearInterval(timer); }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
  }

  /* ------------------------------------------------------------------
     Email pop-up
     ------------------------------------------------------------------ */
  function popup(dlg) {
    if (!dlg.showModal) return;
    var KEY = 'zr_pop_until';
    var days = parseFloat(dlg.getAttribute('data-days')) || 7;
    var delay = (parseFloat(dlg.getAttribute('data-delay')) || 8) * 1000;
    var posted = dlg.hasAttribute('data-posted');
    function snooze(d) { storage(KEY, String(Date.now() + d * 864e5)); }
    function open() {
      if (dlg.open || document.querySelector('dialog[open]')) return;
      dlg.showModal();
      snooze(days);
    }
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-zr-pop-close]')) dlg.close();
    });
    var copy = $('[data-zr-copy]', dlg);
    if (copy) copy.addEventListener('click', function () {
      var code = copy.getAttribute('data-zr-copy');
      var done = function () { copy.textContent = 'Copied'; };
      if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
    });
    if (posted) { open(); snooze(365); return; }
    if (window.Shopify && Shopify.designMode) return;
    var until = parseInt(storage(KEY) || '0', 10);
    if (until > Date.now()) return;
    var t = setTimeout(open, delay);
    document.addEventListener('mouseout', function onOut(e) {
      if (!e.relatedTarget && e.clientY <= 0) { clearTimeout(t); open(); document.removeEventListener('mouseout', onOut); }
    });
  }

  /* ------------------------------------------------------------------
     Animal gallery "show all"
     ------------------------------------------------------------------ */
  function designsMore(btn) {
    btn.addEventListener('click', function () {
      var section = btn.closest('.zr-designs');
      var grid = section && $('[data-zr-designs]', section);
      if (grid) grid.removeAttribute('data-collapsed');
      btn.parentElement.remove();
    });
  }

  /* ------------------------------------------------------------------
     Accordions: animate open/close instead of snapping
     ------------------------------------------------------------------ */
  function accordion(details) {
    var summary = details.querySelector('summary');
    var body = details.querySelector('.zr-acc__body');
    if (!summary || !body || !body.animate) return;
    var anim = null;
    summary.addEventListener('click', function (e) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      e.preventDefault();
      if (anim) anim.cancel();
      var opening = !details.open;
      if (opening) details.open = true;
      var h = body.scrollHeight;
      body.style.overflow = 'hidden';
      anim = body.animate(
        opening
          ? [{ height: '0px', opacity: 0, transform: 'translateY(-6px)' }, { height: h + 'px', opacity: 1, transform: 'none' }]
          : [{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }],
        { duration: opening ? 320 : 240, easing: 'cubic-bezier(.2,.8,.2,1)' }
      );
      anim.onfinish = function () {
        anim = null;
        body.style.overflow = '';
        if (!opening) details.open = false;
      };
    });
  }

  /* ------------------------------------------------------------------
     Scroll reveal: blocks fade up as they enter the screen
     ------------------------------------------------------------------ */
  var REVEAL = '.zr-head, .zr-design, .zr-feat__card, .zr-it__media, .zr-it__body, .zr-news__box, .zr-acc details, .zr-table-wrap, .zr-size-tips > *';
  var revealIO = null;
  function reveal(scope) {
    if (REDUCED || !('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode)) return;
    if (!revealIO) {
      document.documentElement.classList.add('zr-motion');
      revealIO = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          revealIO.unobserve(e.target);
        });
      }, { rootMargin: '0px 0px -8% 0px' });
    }
    $$(REVEAL, scope).forEach(function (el) {
      if (el.hasAttribute('data-zr-reveal')) return;
      // stagger siblings a little so grids ripple in
      var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
      el.style.setProperty('--zr-d', Math.min(sib, 5) * 70 + 'ms');
      el.setAttribute('data-zr-reveal', '');
      revealIO.observe(el);
    });
  }

  /* ------------------------------------------------------------------
     Light copy protection: no right-click menu or dev-tools shortcuts.
     Form fields keep their menu so people can paste addresses.
     ------------------------------------------------------------------ */
  function protect() {
    if (window.Shopify && Shopify.designMode) return;
    document.addEventListener('contextmenu', function (e) {
      if (e.target.closest && e.target.closest('input, textarea, [contenteditable]')) return;
      e.preventDefault();
    });
    document.addEventListener('dragstart', function (e) { if (e.target.tagName === 'IMG') e.preventDefault(); });
    document.addEventListener('keydown', function (e) {
      var k = (e.key || '').toUpperCase();
      var mod = e.ctrlKey || e.metaKey;
      if (k === 'F12' ||
          (mod && e.shiftKey && (k === 'I' || k === 'J' || k === 'C')) ||
          (e.metaKey && e.altKey && (k === 'I' || k === 'J' || k === 'C' || k === 'U')) ||
          (mod && k === 'U')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  function init(scope) {
    reveal(scope);
    $$('[data-zr-product]', scope).forEach(function (el) { if (!el.__zr) { el.__zr = new Product(el); } });
    $$('[data-zr-ann]', scope).forEach(function (el) { if (!el.__zr) { el.__zr = true; announcement(el); } });
    $$('[data-zr-pop]', scope).forEach(function (el) { if (!el.__zr) { el.__zr = true; popup(el); } });
    $$('[data-zr-designs-more]', scope).forEach(function (el) { if (!el.__zr) { el.__zr = true; designsMore(el); } });
    $$('.zr-acc details', scope).forEach(function (el) { if (!el.__zr) { el.__zr = true; accordion(el); } });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); watchCart(); protect(); });
  else { init(); watchCart(); protect(); }

  // Re-run when sections are edited in the theme editor.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
